import { configurationPageList } from 'src/app/utils/constants/strings';

const convertCustomerOnBoarding = response => {
  return response.map(item => ({
    ...configurationPageList.find(list => list.config_id === item.config_id),
  }));
};

export { convertCustomerOnBoarding };
